import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import _ from 'lodash'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import PortfolioHead from 'components/PortfolioHead'
import PortfolioNextPrevLink from 'components/PortfolioNextPrevLink'
import works from 'data/works'
import { findWork } from 'data/works-helper'
import Gallery from 'components/Gallery'
import ReactPlayer from 'react-player'

export default class ReactComponent extends React.Component {

  render () {

    const data = findWork(works, this.props.route.page.path);
    return (
      <div>
        <Helmet
          title={`${config.siteTitle} | Skinspiel`} 
        />
        <PortfolioHead data={data}/>
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >

          <div className="section-header">
            <PortfolioNextPrevLink data={data} />
            <h2>Description</h2>
          </div>
          <p>
            Skinspiel is my graduation project for computer engineering at Chulalongkorn University. 
            It proposed a low-cost alternative for performing projection mapping on moving objects.
          </p>
          <br />

          <p>
            Projection mapping is the technique of projecting video and image on the surface of physical objects in order to distort their appearance in the view of the audience. 
            One of the challenges of projection mapping on moving objects is that it requires the tracking of object orientation in real-time.  
            The task usually requires high-grade motion tracking equipments e.g. infrared motion trackers. Skinspiel provides a cost-effective way to achieve similar results with off-the-shelf hardware and fiducial tracking in cases that some visual clutter on the object is tolerable.
          </p>
          <br />

          <p>
            To demonstrate the approach, a proof of concept system was implemented in C++ with OpenFrameworks.
            It included simple tools for camera-projector calibration and model/media alignment.
          </p>
          <br />

          <div className="section">
            <ReactPlayer url="https://vimeo.com/38460205" className="center-auto" controls="true"/>
          </div>

          <div className="section">
            <PortfolioNextPrevLink data={data} />
          </div>
        </Container>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/skinspiel/index.js
 **/